import * as React from 'react';

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import {
    ISignInItem, ISignInLoading, ISignInLocalAccount, ISignInSocialAccount, ISignInSocialItem,
    ISignInViewProps
} from '@msdyn365-commerce-modules/account-management/src/modules/sign-in/sign-in';
const LocalAccount: React.FC<ISignInLocalAccount> = ({
    localAccount,
    items,
    forgetPassword,
    disclaimer,
    error,
    signInButton
}) => {

    return (
        <Node {...localAccount}>
            {items && items.map((item: ISignInItem) => {
                if (item.key === 'password') {
                    return (
                        <Node key={item.key} {...item.wrapper}>
                            {item.label}
                            {item.error}
                            {item.input}
                            <button className='sign-in-show-password' aria-label='Show/Hide password' onClick={_showPassword}>
                                <i id='sign-in-password-icon' className='icon-show-password'/>
                            </button>
                        </Node>
                    );
                }
                return (
                    <Node key={item.key} {...item.wrapper}>
                        {item.label}
                        {item.error}
                        {item.input}
                    </Node>
                );
            })}
            {disclaimer}
            {error}
            {signInButton}
            <div className='ms-sign-in__container-forget-password'>{forgetPassword}</div>
        </Node>
    );
};

const SocialAccount: React.FC<ISignInSocialAccount> = ({
    socialAccounts,
    items,
}) => {

    return (
        <Node {...socialAccounts}>
            {items && items.map((item: ISignInSocialItem) => {
                return (
                    <Node key={item.key} {...item.button}>
                        {item.image}
                        {item.text}
                    </Node>
                );
            })}
        </Node>
    );
};

const SignInLoading: React.FC<ISignInLoading> = ({
    modal,
    modalBody,
    icon,
    message,
}) => {
    return (
        <Node {...modal}>
            <Node {...modalBody}>
                {icon}
                {message}
            </Node>
        </Node>
    );
};

const SignInView: React.FC<ISignInViewProps> = props => {

    const {
        signIn,
        viewState,
        loading,
        defaultAADConainer,
        aadConainer,
        signInSection,
        signUpSection,
        signInSectionHeading,
        signInLocalAccount,
        signInSocialAccount,
        signUpSectionHeading,
        signUpDescription,
        signUpLink
    } = props;

    return (
        <Module {...signIn}>
            {viewState.isShowLoading && <Node {...defaultAADConainer} />}
            {viewState.isShowLoading && <SignInLoading {...loading} />}
            <Node {...aadConainer}>
                <Node {...signInSection}>
                    {signInSectionHeading}
                    {LocalAccount(signInLocalAccount)}
                    {SocialAccount(signInSocialAccount)}
                </Node>
                <Node {...signUpSection}>
                    {signUpSectionHeading}
                    {signUpDescription}
                    {signUpLink}
                </Node>
            </Node>
        </Module>
    );
};

const _showPassword = () => {
    const passwordState = document.getElementById('password') as HTMLInputElement;
    const iconElement = document.getElementById('sign-in-password-icon');
    if (passwordState && iconElement) {
        passwordState.type = passwordState.type === 'password' ? 'text' : 'password';
        iconElement.className = iconElement.className === 'icon-show-password' ? 'icon-hide-password' :'icon-show-password';
    }
};

export default SignInView;
